/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAudiencesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAudiencesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListAudiencesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAudiencesSecurity$outboundSchema: z.ZodMiniType<
  ListAudiencesSecurity$Outbound,
  ListAudiencesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAudiencesSecurityToJSON(
  listAudiencesSecurity: ListAudiencesSecurity,
): string {
  return JSON.stringify(
    ListAudiencesSecurity$outboundSchema.parse(listAudiencesSecurity),
  );
}

/** @internal */
export type ListAudiencesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListAudiencesRequest$outboundSchema: z.ZodMiniType<
  ListAudiencesRequest$Outbound,
  ListAudiencesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listAudiencesRequestToJSON(
  listAudiencesRequest: ListAudiencesRequest,
): string {
  return JSON.stringify(
    ListAudiencesRequest$outboundSchema.parse(listAudiencesRequest),
  );
}
